document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('wcl-header');
    if (!header) return;

    const burger = header.querySelector('.wcl-header__burger');
    const close  = header.querySelector('.wcl-header__close');

    const openMenu = () => {
        header.classList.add('wcl-header--open');
        document.body.classList.add('overflow-hidden');
    };

    const closeMenu = () => {
        header.classList.remove('wcl-header--open');
        document.body.classList.remove('overflow-hidden');
    };

    // Mobile search toggle
    const searchToggle = header.querySelector('.wcl-header__search-toggle');
    const searchPanel  = document.getElementById('wcl-mobile-search');
    const searchInput  = document.getElementById('wcl-mobile-search-input');

    const openSearch = () => {
        searchPanel.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        searchInput?.focus();
    };

    const closeSearch = () => {
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
    };

    searchToggle?.addEventListener('click', () => {
        searchPanel.classList.contains('is-open') ? closeSearch() : openSearch();
    });

    burger?.addEventListener('click', openMenu);
    close?.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeMenu();
    });

    // Mobile submenu toggle
    header.querySelectorAll('.wcl-header__mobile-menu .menu-item-has-children > a').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const item    = link.closest('.menu-item-has-children');
            const subMenu = item.querySelector('.sub-menu');
            const isOpen  = item.classList.toggle('is-open');

            subMenu.style.maxHeight = isOpen ? subMenu.scrollHeight + 'px' : '0';
        });
    });
});
